import { render, staticRenderFns } from "./parentReward.vue?vue&type=template&id=99db276e&scoped=true&"
import script from "./parentReward.vue?vue&type=script&lang=js&"
export * from "./parentReward.vue?vue&type=script&lang=js&"
import style0 from "./parentReward.vue?vue&type=style&index=0&id=99db276e&scoped=true&lang=scss&"
import style1 from "./parentReward.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99db276e",
  null
  
)

export default component.exports